// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

// Whole-app license lock: while locked, every route redirects to /license-expired.
export const licenseSlice = createSlice({
    name: "license",
    initialState: { isLocked: false },
    reducers: {
        setLicenseLocked: (state, action) => {
            state.isLocked = Boolean(action.payload);
        }
    }
});

export const { setLicenseLocked } = licenseSlice.actions;

export default licenseSlice.reducer;
